// extracted by mini-css-extract-plugin
export default {"container":"DropdownLabel_container__oO9BN","disabled":"DropdownLabel_disabled__JK6yS","bootstrap":"DropdownLabel_bootstrap__3abQx"};